import { createServerFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { z } from "zod";

export const getPublicSalon = createServerFn({ method: "GET" })
  .inputValidator((input: unknown) =>
    z.object({ slug: z.string().min(1).max(80) }).parse(input),
  )
  .handler(async ({ data }) => {
    const { loadPublicSalon } = await import("./landing.server");
    return loadPublicSalon(data.slug);
  });

export const trackLandingEvent = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) =>
    z
      .object({
        slug: z.string().min(1).max(80),
        type: z.enum(["view", "call", "book"]),
      })
      .parse(input),
  )
  .handler(async ({ data }) => {
    const { recordLandingEvent } = await import("./landing.server");
    return recordLandingEvent({
      slug: data.slug,
      type: data.type,
      referrer: getRequestHeader("referer") ?? null,
    });
  });
